// src/onus_components/AccionOntModal.jsx — reiniciar o dejar de fábrica
//
// Son DOS cosas distintas y están juntas aquí para que no vuelvan a
// confundirse:
//
//   ont reset                     apaga y enciende. No borra nada.
//   ont factory-setting-restore   la deja como salió de la caja:
//                                 sin PPPoE, sin WiFi, sin TR069.
//
// Durante un tiempo el botón «Reiniciar» mandaba el segundo.

import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";
import { Iconos } from "../componentes/base";
import ModalPasos, { fichaOnu, leerRespuesta, ubicacionDe } from "../componentes/olt/ModalPasos";

const ACCIONES = {
  reiniciar: {
    titulo: "Reiniciar la ONT",
    ruta: "reiniciar",
    verbo: "Reiniciar",
    icono: Iconos.reiniciar,
    peligro: false,
    orden: "ont reset",
    rotulo: "Mandar el reinicio",
    aviso: "Se apaga y se enciende. No pierde nada de lo configurado —PPPoE, WiFi y TR069 siguen igual—, pero el cliente se queda sin internet el minuto o minuto y medio que tarda en arrancar.",
    fin: "Reinicio enviado. La ONT vuelve en un minuto o minuto y medio.",
  },
  fabrica: {
    titulo: "Dejar la ONT de fábrica",
    ruta: "factory_reset",
    verbo: "Restaurar de fábrica",
    icono: Iconos.restablecer,
    peligro: true,
    orden: "ont factory-setting-restore",
    rotulo: "Mandar el borrado",
    aviso: "BORRA la configuración de la ONT: PPPoE, WiFi y TR069 se pierden y hay que volver a dejarla como estaba. Si solo quieres apagarla y encenderla, eso es «Reiniciar».",
    fin: "Restaurada de fábrica. Hay que volver a configurarle WAN y TR069.",
  },
};

export default function AccionOntModal({ open, onu, accion = "reiniciar", onClose, onSuccess }) {
  const [estado, setEstado] = useState("reposo");
  const [salida, setSalida] = useState([]);
  const [error, setError] = useState("");

  const cfg = ACCIONES[accion] || ACCIONES.reiniciar;
  const u = ubicacionDe(onu);

  useEffect(() => {
    if (!open) return;
    setEstado("reposo"); setSalida([]); setError("");
  }, [open, onu?.id, accion]);

  async function ejecutar() {
    const id = onu?.onu_db_id ?? onu?.id;
    if (!id) return;
    setEstado("corriendo"); setSalida([]); setError("");
    try {
      const res = await authFetch(`/api/onus/${id}/${cfg.ruta}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      const data = await leerRespuesta(res);
      setSalida(Array.isArray(data?.outputs) ? data.outputs : []);
      if (!res.ok || !data?.ok) throw new Error(data?.mensaje || `No se pudo ${cfg.verbo.toLowerCase()}.`);
      onSuccess?.(data?.mensaje || cfg.fin);
    } catch (e) {
      setError(String(e?.message || e));
    } finally {
      setEstado("fin");
    }
  }

  return (
    <ModalPasos
      abierto={open}
      titulo={cfg.titulo}
      icono={cfg.icono}
      ficha={fichaOnu(onu)}
      aviso={cfg.aviso}
      peligro={cfg.peligro}
      verbo={cfg.verbo}
      estado={estado}
      salida={salida}
      error={error}
      mensaje={cfg.fin}
      fases={[
        { rotulo: "Entrar al puerto", coincide: /^interface gpon/, cmds: [`interface gpon ${u.frameSlot}`] },
        { rotulo: cfg.rotulo, coincide: /^(ont (reset|factory-setting-restore)|y)\b/, cmds: [`${cfg.orden} ${u.pon} ${u.ont}`] },
        { rotulo: "Salir del puerto", coincide: /^quit$/, cmds: ["quit"] },
      ]}
      onEjecutar={ejecutar}
      onCerrar={onClose}
    />
  );
}
